import tw, { css } from 'twin.macro'

export const errorIconBasicStyles = tw`
  pointer-events-none
  h-5 w-5
  text-red-500
`

// We can't interpolate strings on babel macros so reusing
// the contents of focus|focus-within is not possible/intuitive
export const focusStyles = css`
  /** Reset native outline */
  ${tw`focus:outline-none`}
  ${tw`focus:ring-2 focus:ring-brand-neutral`}

  /** Hide border as we already show the focus-ring */
  :focus:focus-visible {
    ${tw`border-transparent`}
  }

  /** Hide outline for anything that's not an input, textarea or select */
  /** If browser doesn't support focus-visible, the rule is just ignored */
  :not(select, input, textarea):focus:not(:focus-visible) {
    outline: none !important;
    box-shadow: none !important;
  }
`

export const focusWithinStyles = tw`
  focus-within:outline-none
  focus-within:ring-2
  focus-within:ring-brand-neutral
  focus-within:border-transparent
`

export const inputInnerStyles = tw`
  p-2.5
  text-sm-brand
  text-default-neutral
  font-brand
  leading-5
`

export const inputStyles = [
  inputInnerStyles,
  tw`
    block
    w-full
    border-none
    appearance-none
    rounded-md
    min-w-0
    text-default-neutral
    bg-default-subdued
    placeholder:text-default-muted

    focus:outline-none
    disabled:bg-default-muted
  `,
  css`
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      ${tw`m-0 appearance-none`}
    }
  `,
]

export const inputErrorStyles = tw`text-red-900`

export const inputSlotBasicStyles = tw`
  flex
  items-center
  mx-2
  text-default-muted
  leading-5
`

export const inputWrapperStyles = [
  focusWithinStyles,
  tw`
    relative
    inline-flex
    w-full
    border rounded-md border-default-emphasis
    shadow-sm
    text-base leading-normal
  `,
]

export const inputWrapperErrorStyles = tw`
  border-red-300
  placeholder-red-300
  focus-within:ring-red-500
`
